module.exports = __webpack_public_path__ + "img/allergens.268c2578.svg";